import { useTheme } from '@mui/material/styles';
import { ContentCard } from 'components/Card/ContentCard';
import { InfoCard } from 'components/notification-cards';
import { Text } from 'components/Text';
import { useAssignmentDetails } from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import { AssignmentChangeLogSkeleton } from './AssignmentChangeLogSkeleton';
import { ChangeItem } from './ChangeItem';

export const AssignmentChangeLog = () => {
  const { isLoading, assignmentDetails } = useAssignmentDetails();
  const theme = useTheme();

  if (isLoading) return <AssignmentChangeLogSkeleton />;

  if (!assignmentDetails) return null;

  const { assignmentChanges } = assignmentDetails;

  return (
    <ContentCard
      title={getTrans('assignmentDetailsPage.changeLog.title')}
      sx={{
        pb: 0,
        [theme.breakpoints.up('sm')]: {
          pb: 0
        },
        '& > div:first-of-type': {
          mb: 1
        }
      }}
    >
      {assignmentChanges?.length ? (
        assignmentChanges.map(changeData => (
          <ChangeItem key={changeData.refId} changeData={changeData} />
        ))
      ) : (
        <InfoCard sx={{ mb: 2 }}>
          <Text variant="body2">
            {getTrans('assignmentDetailsPage.changeLogInfo')}
          </Text>
        </InfoCard>
      )}
    </ContentCard>
  );
};
